import React from "react";
import "./ChatSkeletonLoader.css";

const getRandomWidth = () => {
  const widths = ["40%", "50%", "60%", "70%", "80%"];
  return widths[Math.floor(Math.random() * widths.length)];
};

const getRandomHeight = () => {
  const heights = ["3rem", "4rem", "3rem", "6rem", "4rem"];
  return heights[Math.floor(Math.random() * heights.length)];
};

const ChatSkeletonLoader = () => {
  return (
    <div className="chat-skeleton-wrapper">
      {[...Array(8)].map((_, i) => (
        <div
          key={i}
          className={`chat-skeleton-bubble shimmer ${i % 2 === 0 ? "left" : "right"}`}
          style={{
            width: getRandomWidth(),
            height: getRandomHeight(),
          }}
        />
      ))}
    </div>
  );
};

export default ChatSkeletonLoader;
